type TNameParts = {
    name?: string | null;
    surname?: string | null;
};

/**
 * Сущности API (клиент, работник и т.п.) хранят имя либо на себе,
 * либо во вложенном пользователе — тип описывает оба варианта структурно,
 * чтобы утилита работала с TUser, TWorkerPosition, TCustomer и др.
 */
type TUserNameSource = TNameParts & {
    user?: TNameParts | null;
};

function getUserFullName(source: TUserNameSource | null | undefined, fallback = ''): string {
    if (!source) return fallback;

    const name = source.name || source.user?.name;
    const surname = source.surname || source.user?.surname;

    return [name, surname].filter(Boolean).join(' ') || fallback;
}

export { getUserFullName };
export type { TUserNameSource };
